import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'ShiftShipmentRTOToHub',
  components: {
      VueElementLoading,
      Treeselect,
      Paginate,
  },
  mixins:[PageTracker],
  data: function() {
      return {
        txtShipmentId : '',
        showInfo : false,
        shippingId : '',
        Status : '',
        shipmentStatus : '',
        shipDetails :{
          Pincode : '',
          State : '',
          City : '',
          Address : '',
          email : ''
        },
        StateObj : [{"stateid" : "1","statename" : "MH"}],
        CityObj : [{"cityid" : '1',"cityname":"Pune"}],
      }
  },
  created: function() {
      //this.getCity();
      this.getState();
  },
  async mounted(){
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
  },
  methods : {
     getState(){
      axios.get(apiUrl.api_url + 'getstate/list', {})
       .then((response) => {
           if(response.data.code===200){
               this.StateObj =response.data.data;
               //console.log("this.StateObj",this.StateObj);
           }
           else {
               this.StateObj=[];
           }
       })
       .catch((httpException) => {
           this.$alertify.error("State data not found");
           console.error('exception is:::::::::', httpException)
       })
     },
     getCity(){
       let stateId = this.shipDetails.State.toString();
       console.log('id: ',typeof(stateId));
       axios.post(apiUrl.api_url + 'city/list', {"stateId":stateId})
        .then((response) => {
          console.log("response 1111",response);
            if(response.data.code===200){
                this.CityObj =response.data.data;
                console.log('this.CityObj : ',this.CityObj);
            }
            else {
                this.CityObj=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("City data not found");
            console.error('exception is:::::::::', httpException)
        })
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('form submited');

          var updateAddress = {
              shipmentId : this.txtShipmentId,
          }
          this.showInfo = true;
          this.shippingId = this.txtShipmentId,
          this.Status = 'Shipped',
          this.shipmentStatus = 'Inscan'
          console.log('Payload: ',updateAddress);


        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm1(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log('form submited');

          var updateCustomer = {
              address: this.shipDetails.Address,
              city: this.shipDetails.City,
              state: this.shipDetails.State,
              pin: this.shipDetails.Pincode,
              email: this.shipDetails.email
          }
          console.log('Payload2: ',updateCustomer);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    clear(){
      this.txtShipmentId = '',
      this.shippingId = '',
      this.Status = '',
      this.shipmentStatus = ''
      this.showInfo = false;
      this.$validator.reset();
      this.errors.clear();
    },
    onlyNumber : function($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
       if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8) {
          $event.preventDefault();
       }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdateCustomerDetails/UpdateCustomerDetails.component.js